import { combineReducers } from 'redux';
import { notificationReducer, toastReducer } from '@ordermentum/ui-toast';
import { flagsReducer } from '@ordermentum/ui-shared/redux/flags';
import {
  cardsReducer,
  purchaserReducer,
} from '@ordermentum/ui-shared/redux/retailers';
import { CONSTANTS } from '../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export type stateT = {
  data: any;
  loading: boolean;
  error: any;
};

export type actionT = {
  type: string;
  data?: any;
  error?: any;
};

const profileReducer = function (
  state: stateT = initialState,
  action: actionT
) {
  switch (action.type) {
    case CONSTANTS.FETCH_PROFILE_DETAILS_REQUEST: {
      return { ...state, loading: true };
    }
    case CONSTANTS.FETCH_PROFILE_DETAILS_SUCCESS: {
      return { ...state, data: action.data, error: {}, loading: false };
    }

    case CONSTANTS.FETCH_PROFILE_DETAILS_FAILURE: {
      return {
        ...state,
        data: initialState.data,
        error: action.error,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default combineReducers({
  notifications: notificationReducer,
  toasts: toastReducer,
  flags: flagsReducer,
  profile: profileReducer,
  addNewCard: cardsReducer,
  purchaserDetails: purchaserReducer,
});
